var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maxCount > 0)?_c('span',{staticClass:"character-count",class:{hide: !_vm.inputFocus},attrs:{"role":"alert","aria-live":"polite","aria-relevant":"additions"}},[_vm._v(_vm._s(_vm.charactersRemaining))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }